import React from "react";
import { CloseIcon, CopyIcon } from "../../../commonUI/Icons/SvgIcon";

const NotificationDetailsPanel = ({ notification, onClose }) => {
  if (!notification) return null;

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  const getStatusBadgeClass = (status) => {
    if (status === "Delivered" || status === "Delivery unconfirmed") {
      return "status-badge status-badge--success";
    }
    if (status === "Failed to send" || status === "Cancelled") {
      return "status-badge status-badge--error";
    }
    return "status-badge status-badge--warning";
  };

  return (
    <>
      <div className="discount-modal-overlay" onClick={onClose}></div>
      <div className="right-modal discount-modal">
        <div className="modal-header">
          <div className="modal-title">
            <h2>Notification details</h2>
            <button className="modal-close-btn" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label>Recipient</label>
            <div className="notif-details-panel__recipient notif-details-panel__recipient--mb">
              <div
                className="notif-details-panel__avatar"
                style={{ backgroundColor: notification.recipient.avatarColor }}
              >
                {notification.recipient.initials}
              </div>
              <div className="notif-details-panel__recipient-info">
                <div className="notif-details-panel__recipient-name">
                  {notification.recipient.name}
                </div>
                <div className="notif-details-panel__recipient-id">
                  {notification.recipient.id}
                </div>
              </div>
              <button
                className="notif-details-panel__view-profile-btn"
                type="button"
              >
                View profile
              </button>
            </div>

            <div className="notif-details-panel__field notif-details-panel__field--mb">
              <label className="notif-details-panel__field-label">Email</label>
              <div className="notif-details-panel__field-value">
                {notification.recipient.email || "N/A"}
              </div>
            </div>
          </div>

          <div className="form-group">
            <div className="notif-details-panel__grid-row notif-details-panel__grid-row--mb">
              <div className="notif-details-panel__grid-col">
                <label className="notif-details-panel__field-label">
                  Category
                </label>
                <div className="notif-details-panel__field-value">
                  {notification.category}
                </div>
              </div>
              <div className="notif-details-panel__grid-col">
                <label className="notif-details-panel__field-label">
                  Message
                </label>
                <div className="notif-details-panel__field-value">
                  {notification.message}
                </div>
              </div>
            </div>

            <div className="notif-details-panel__grid-row notif-details-panel__grid-row--mb">
              <div className="notif-details-panel__grid-col">
                <label className="notif-details-panel__field-label">
                  Channel
                </label>
                <div className="notif-details-panel__field-value">
                  {notification.channel}
                </div>
              </div>
              <div className="notif-details-panel__grid-col">
                <label className="notif-details-panel__field-label">
                  Status
                </label>
                <div className={getStatusBadgeClass(notification.status)}>
                  {notification.status}
                </div>
              </div>
            </div>

            <div className="notif-details-panel__grid-row">
              <div className="notif-details-panel__grid-col">
                <label className="notif-details-panel__field-label">
                  Recorded
                </label>
                <div className="notif-details-panel__field-value">
                  {notification.date}, {notification.time}
                </div>
              </div>
              <div className="notif-details-panel__grid-col">
                <label className="notif-details-panel__field-label">
                  Last updated
                </label>
                <div className="notif-details-panel__field-value">
                  {notification.date}, {notification.time}
                </div>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>Message content</label>
            <div className="notif-details-panel__message-content">
              {notification.messageContent ||
                "Not recorded for this notification."}
            </div>
          </div>

          {(notification?.status === "Failed to send" ||
            notification.status === "Cancelled") &&
            notification.errorMessage && (
              <>
                <div className="notif-details-panel__error-alert">
                  <div className="notif-details-panel__error-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                  </div>
                  <div className="notif-details-panel__error-message">
                    {notification.errorMessage}
                  </div>
                </div>

                <div className="notif-details-panel__context-note">
                  Illustrative demo context; these references do not link to
                  live records.
                </div>

                <div className="form-group">
                  <label>Related records</label>

                  {notification.relatedRecords?.reviewRating && (
                    <div className="notif-details-panel__field notif-details-panel__field--mb">
                      <label className="notif-details-panel__field-label">
                        Review rating
                      </label>
                      <div className="notif-details-panel__field-value">
                        {notification.relatedRecords.reviewRating}
                      </div>
                    </div>
                  )}

                  {notification.relatedRecords &&
                    (notification.relatedRecords.serviceDescription ||
                      notification.relatedRecords.route) && (
                      <div className="notif-details-panel__grid-row notif-details-panel__grid-row--mb">
                        {notification.relatedRecords.serviceDescription && (
                          <div className="notif-details-panel__grid-col">
                            <label className="notif-details-panel__field-label">
                              Service description
                            </label>
                            <div className="notif-details-panel__field-value">
                              {notification.relatedRecords.serviceDescription}
                            </div>
                          </div>
                        )}
                        {notification.relatedRecords.route && (
                          <div className="notif-details-panel__grid-col">
                            <label className="notif-details-panel__field-label">
                              Route
                            </label>
                            <div className="notif-details-panel__field-value">
                              {notification.relatedRecords.route}
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                  {notification.relatedRecords?.requestedJobDate && (
                    <div className="notif-details-panel__field notif-details-panel__field--mb">
                      <label className="notif-details-panel__field-label">
                        Requested job date
                      </label>
                      <div className="notif-details-panel__field-value">
                        {notification.relatedRecords.requestedJobDate}
                      </div>
                    </div>
                  )}

                  {notification.relatedRecords?.jobId && (
                    <div className="notif-details-panel__field notif-details-panel__field--mb">
                      <label className="notif-details-panel__field-label">
                        Job ID
                      </label>
                      <div className="badge copyCode-btn">
                        <span>{notification.relatedRecords.jobId}</span>
                        <button
                          onClick={() =>
                            copyToClipboard(notification.relatedRecords.jobId)
                          }
                          className="notif-details-panel__copy-btn"
                          type="button"
                        >
                          <CopyIcon width="14" height="14" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}

          <div className="form-group">
            <label>Technical details</label>

            <div className="notif-details-panel__field notif-details-panel__field--mb">
              <label className="notif-details-panel__field-label">
                Notification ID
              </label>
              <div className="badge copyCode-btn">
                <span>{notification.notificationId || "N/A"}</span>
                <button
                  onClick={() =>
                    copyToClipboard(notification.notificationId || "")
                  }
                  className="notif-details-panel__copy-btn"
                  type="button"
                >
                  <CopyIcon width="14" height="14" />
                </button>
              </div>
            </div>

            <div className="notif-details-panel__field notif-details-panel__field--mb">
              <label className="notif-details-panel__field-label">
                Activity ID
              </label>
              <div className="badge copyCode-btn">
                <span>{notification.activityId || "N/A"}</span>
                <button
                  onClick={() => copyToClipboard(notification.activityId || "")}
                  className="notif-details-panel__copy-btn"
                  type="button"
                >
                  <CopyIcon width="14" height="14" />
                </button>
              </div>
            </div>

            <div className="notif-details-panel__grid-row">
              <div className="notif-details-panel__grid-col">
                <label className="notif-details-panel__field-label">
                  Recipient ID
                </label>
                <div className="badge copyCode-btn">
                  <span>{notification.recipient.id}</span>
                  <button
                    onClick={() => copyToClipboard(notification.recipient.id)}
                    className="notif-details-panel__copy-btn"
                    type="button"
                  >
                    <CopyIcon width="14" height="14" />
                  </button>
                </div>
              </div>
              <div className="notif-details-panel__grid-col">
                <label className="notif-details-panel__field-label">
                  Recipient type
                </label>
                <div className="notif-details-panel__field-value">
                  {notification.recipientType || "Driver"}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default NotificationDetailsPanel;
